import { Input, Slider, SliderSingleProps } from 'antd'
import { useState } from 'react'

import ResetIcon from '@/assets/icons/reset.svg?react'

export function SliderInput({
  defaultValue,
  min,
  max,
  unit,
  step = 1,
  onChange,
}: {
  defaultValue: number
  min: number
  max: number
  unit?: string
  step?: number
  onChange: (value: number) => void
}) {
  const [value, setValue] = useState(defaultValue)

  const marks: SliderSingleProps['marks'] = {
    [min]: (
      <div className="t-xs text-tertiary flex max-w-full mt-1">{`${min}${unit ? ` ${unit}` : ''}`}</div>
    ),
    [max]: (
      <div className="t-xs text-tertiary flex max-w-full mt-1">{`${max}${unit ? `${unit}` : ''}`}</div>
    ),
  }

  const handleChange = (newValue: number) => {
    // 限制 newValue 在 min 和 max 範圍內
    const adjustedValue = Math.max(min, Math.min(newValue, max))
    setValue(adjustedValue)
    onChange(adjustedValue)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = Number(e.target.value)
    handleChange(inputValue)
  }

  const handleReset = () => {
    setValue(defaultValue)
    onChange(defaultValue)
  }

  return (
    <div className="flex items-center">
      <div className="flex-grow mt-4">
        <Slider
          min={min}
          max={max}
          value={value}
          marks={marks}
          step={step}
          onChange={handleChange}
        />
      </div>
      <Input
        type="number"
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={handleInputChange}
        suffix={<div className="t-sb text-tertiary">{unit}</div>}
        className="w-20 mx-4 px-4 py-3 t-sb text-primary rounded-lg"
      />
      <ResetIcon width={20} height={20} className="cursor-pointer" onClick={handleReset} />
    </div>
  )
}
